import { GlobalFeatureFlagConstants } from '../constants/globalFeatureFlag.constants'

// Points Document API calls at the Document Service API when the flag is on and the environment
// sets DOCUMENT_SERVICE_API_URL. Services read window.config.DOCUMENT_API_URL on every call, so
// calls made before the global feature flags load go to the Document API.
export const applyDocumentServiceApiFlag = (flags: Record<string, boolean>) => {
    if (
        flags[GlobalFeatureFlagConstants.UseDocumentServiceApi_77590] &&
        window.config.DOCUMENT_SERVICE_API_URL
    ) {
        window.config.DOCUMENT_API_URL = window.config.DOCUMENT_SERVICE_API_URL
    }
}
